
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus, Save } from 'lucide-react';
import { SubscriptionPlan } from '@/types/subscriptionPlans';
import PlanEditForm from './PlanEditForm';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface PlansManagementTabProps {
  plans: SubscriptionPlan[];
  isSaving: boolean;
  onUpdatePlan: (index: number, field: keyof SubscriptionPlan, value: any) => void;
  onAddNewPlan: () => void;
  onDeletePlan: (index: number) => void;
  onSavePlans: () => Promise<void>;
}

const PlansManagementTab: React.FC<PlansManagementTabProps> = ({
  plans,
  isSaving,
  onUpdatePlan,
  onAddNewPlan,
  onDeletePlan,
  onSavePlans
}) => {
  return (
    <Card className="border-none shadow-lg bg-gradient-to-br from-white to-blue-50">
      <CardHeader className="flex flex-row justify-between items-center pb-2">
        <CardTitle className="text-xl text-primary-blue">Subscription Plans</CardTitle>
        <Button onClick={onAddNewPlan} className="flex items-center bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white shadow-md">
          <Plus className="mr-2 h-4 w-4" />
          Add New Plan
        </Button>
      </CardHeader>
      
      <CardContent className="space-y-6">
        {plans.map((plan, index) => (
          <PlanEditForm
            key={plan.id}
            plan={plan}
            index={index}
            onUpdatePlan={onUpdatePlan}
            onDeletePlan={onDeletePlan}
          />
        ))}
        
        <div className="flex justify-end">
          <Button 
            onClick={onSavePlans} 
            disabled={isSaving}
            className="flex items-center bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white shadow-md"
          >
            {isSaving ? (
              <>
                <div className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-b-transparent"></div>
                Saving...
              </>
            ) : (
              <>
                <Save className="mr-2 h-4 w-4" />
                Save All Plans
              </>
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default PlansManagementTab;
